export const Category = [
  { category: 'Slot machine', category_code: 'slot' },
  { category: 'Arcade', category_code: 'arcade' },
  { category: 'Fish', category_code: 'fish' },
  { category: 'Table', category_code: 'table' },
  { category: 'Live Casino', category_code: 'live' },
  { category: 'PVP', category_code: 'pvp' },
  { category: 'Other', category_code: 'other' },
];
